import { render, staticRenderFns } from "./FormRegions.vue?vue&type=template&id=a3c2b230&"
import script from "./FormRegions.vue?vue&type=script&lang=js&"
export * from "./FormRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports